import React from 'react'
import { createPortal } from 'react-dom'

export default ({ id, children }) => createPortal(<div>{children}</div>, document.getElementById(id))